import styled from 'react-emotion'

const LabelContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  label {
    margin-bottom: 0;
  }
`

export default LabelContainer



// WEBPACK FOOTER //
// ./src/routes/home/components/LabelContainer.js